
import { computed } from '@vue/composition-api';
import type Sale from '~/type/Sale';
interface Props {
  sale: Sale;
  type: 'list' | 'grid' | 'card';
}
const __sfc_main = {};
__sfc_main.props = {
  sale: {
    key: "sale",
    required: true,
    type: null
  },
  type: {
    key: "type",
    required: false,
    type: String,
    default: 'card'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const styles = computed(() => {
    return {
      color: props.sale.marker?.text || props.sale.marker.background,
      borderColor: props.sale.marker?.border || props.sale.marker.background + 64,
      backgroundColor: props.sale.marker?.text && props.sale.marker?.border ? props.sale.marker.background : props.sale.marker.background + 16
    };
  });
  return {
    styles
  };
};
export default __sfc_main;
